import { RelatedProductResponseDto, ServiceOption } from '../dto/relatedproducts.dto';
import { environment } from '../enviroment/environment';
import { ApiService } from './Apiservice';
import axios from 'axios';

export interface ServiceOptionsResponse {
  success: boolean;
  data: ServiceOption[] | { children: ServiceOption[] };
  message?: string;
}

class RelatedProductService {
  private apiRootServer = environment.api.apiRootServer;
  private __Apiservice: ApiService;

  constructor() {
    const axiosInstance = axios.create();
    this.__Apiservice = new ApiService(axiosInstance, this.apiRootServer);
  }

  async getRelatedProducts(idOrSlug: string): Promise<RelatedProductResponseDto> {
    return this.__Apiservice.getRequest(`products/${idOrSlug}/related`, {}, {
      apiRoot: this.apiRootServer,
    });
  }

  async getServiceByType(idOrSlug: string): Promise<ServiceOptionsResponse> {
    return this.__Apiservice.getRequest(`service-options/${idOrSlug}`, {}, {
      apiRoot: this.apiRootServer,
    }) as Promise<ServiceOptionsResponse>;
  }
}

// Create an instance of the service
const relatedProductService = new RelatedProductService();

export default relatedProductService;